import { useMemo } from 'react'
import type { EnabledFilters } from 'components/Search/type'
import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'

export default function useHomesAndVillasEnabledFilters(isAnywhereSearch: boolean): EnabledFilters {
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const enabledFilters: EnabledFilters = useMemo(() => ({
    inclusions: true,
    amenities: true,
    propertyFacilities: true,
    customerRating: true,
    priceFilter: config.ENABLE_HOTEL_SEARCH_PAGE_PRICE_FILTER,
    holidayTypes: true,
    propertyTypes: false,
    locations: isAnywhereSearch,
    bedrooms: true,
    popularFilters: false,
    homesAndVillasPopularFilters: true,
    beds: true,
    bathrooms: true,
    bedTypes: true,
    luxPlusFeatures: luxPlusEnabled,
    agentHubFeatures: config.agentHub.isEnabled,
    chains: false,
  }), [luxPlusEnabled, isAnywhereSearch])

  return enabledFilters
}
